/**
 * @generated SignedSource<<73ec79fdd57cf741f7bbec6537f45e7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FormsEnsureDraftResponseMutationInput = {
  clientMutationId?: string | null;
  formId: string;
};
export type RespondForm_ensureDraftResponse_Mutation$variables = {
  input: FormsEnsureDraftResponseMutationInput;
};
export type RespondForm_ensureDraftResponse_Mutation$data = {
  readonly ensureDraftResponse: {
    readonly folderNode: {
      readonly canEdit?: {
        readonly value: boolean;
      };
      readonly id?: string;
    };
    readonly response: {
      readonly answers: ReadonlyArray<{
        readonly id: string;
        readonly questionId: string;
        readonly value: {
          readonly __typename: "CustomValue__Checkboxes";
          readonly checkboxes: ReadonlyArray<string> | null;
        } | {
          readonly __typename: "CustomValue__Date";
          readonly date: DateString  | null;
        } | {
          readonly __typename: "CustomValue__DateTime";
          readonly dateTime: ISO8601DateTimeString | null;
        } | {
          readonly __typename: "CustomValue__Email";
          readonly email: string | null;
        } | {
          readonly __typename: "CustomValue__Link";
          readonly link: string | null;
        } | {
          readonly __typename: "CustomValue__MultipleChoice";
          readonly multipleChoice: string | null;
        } | {
          readonly __typename: "CustomValue__Numeric";
          readonly number: number | null;
        } | {
          readonly __typename: "CustomValue__PhoneNumber";
          readonly phoneNumber: string | null;
        } | {
          readonly __typename: "CustomValue__String";
          readonly text: string | null;
        } | {
          readonly __typename: "CustomValue__Time";
          readonly time: TimeOfDayString | null;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"RespondForm_Response">;
    };
  } | null;
};
export type RespondForm_ensureDraftResponse_Mutation = {
  response: RespondForm_ensureDraftResponse_Mutation$data;
  variables: RespondForm_ensureDraftResponse_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    {
      "alias": "canEdit",
      "args": null,
      "concreteType": "AuthorizationResult",
      "kind": "LinkedField",
      "name": "canRename",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FolderItem",
  "abstractKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "FormResponseAnswer",
  "kind": "LinkedField",
  "name": "answers",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "questionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "text",
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "type": "CustomValue__String",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "number",
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "type": "CustomValue__Numeric",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "checkboxes",
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "type": "CustomValue__Checkboxes",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "multipleChoice",
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "type": "CustomValue__MultipleChoice",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "date",
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "type": "CustomValue__Date",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "time",
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "type": "CustomValue__Time",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "dateTime",
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "type": "CustomValue__DateTime",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "phoneNumber",
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "type": "CustomValue__PhoneNumber",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "link",
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "type": "CustomValue__Link",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "email",
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "type": "CustomValue__Email",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RespondForm_ensureDraftResponse_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FormsEnsureDraftResponseMutationPayload",
        "kind": "LinkedField",
        "name": "ensureDraftResponse",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "folderNode",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FormResponse",
            "kind": "LinkedField",
            "name": "response",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "RespondForm_Response"
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RespondForm_ensureDraftResponse_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FormsEnsureDraftResponseMutationPayload",
        "kind": "LinkedField",
        "name": "ensureDraftResponse",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "folderNode",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FormResponse",
            "kind": "LinkedField",
            "name": "response",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "respondedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Member",
                "kind": "LinkedField",
                "name": "responder",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7b7b48146fbe1223baa760eb1af859fa",
    "id": null,
    "metadata": {},
    "name": "RespondForm_ensureDraftResponse_Mutation",
    "operationKind": "mutation",
    "text": "mutation RespondForm_ensureDraftResponse_Mutation(\n  $input: FormsEnsureDraftResponseMutationInput!\n) {\n  ensureDraftResponse(input: $input) {\n    folderNode {\n      __typename\n      ... on FolderItem {\n        id\n        canEdit: canRename {\n          value\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    response {\n      ...RespondForm_Response\n      answers {\n        id\n        questionId\n        value {\n          __typename\n          ... on CustomValue__String {\n            text: value\n          }\n          ... on CustomValue__Numeric {\n            number: value\n          }\n          ... on CustomValue__Checkboxes {\n            checkboxes: value\n          }\n          ... on CustomValue__MultipleChoice {\n            multipleChoice: value\n          }\n          ... on CustomValue__Date {\n            date: value\n          }\n          ... on CustomValue__Time {\n            time: value\n          }\n          ... on CustomValue__DateTime {\n            dateTime: value\n          }\n          ... on CustomValue__PhoneNumber {\n            phoneNumber: value\n          }\n          ... on CustomValue__Link {\n            link: value\n          }\n          ... on CustomValue__Email {\n            email: value\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment RespondForm_Response on FormResponse {\n  id\n  state\n  respondedAt\n  responder {\n    name\n    id\n  }\n  answers {\n    id\n    questionId\n    value {\n      __typename\n      ... on CustomValue__String {\n        text: value\n      }\n      ... on CustomValue__Numeric {\n        number: value\n      }\n      ... on CustomValue__Checkboxes {\n        checkboxes: value\n      }\n      ... on CustomValue__MultipleChoice {\n        multipleChoice: value\n      }\n      ... on CustomValue__Date {\n        date: value\n      }\n      ... on CustomValue__Time {\n        time: value\n      }\n      ... on CustomValue__DateTime {\n        dateTime: value\n      }\n      ... on CustomValue__PhoneNumber {\n        phoneNumber: value\n      }\n      ... on CustomValue__Link {\n        link: value\n      }\n      ... on CustomValue__Email {\n        email: value\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "02eb74a0056e0a191ce8cfeea8c02b1c";

export default node;
